import PropTypes from "prop-types";
import React from "react";
import Arrow from "../../assets/assets/arrow_right_alt-24px.svg";
import ReapplyDoc from "../../assets/assets/reapply-docs.svg";
import ReapplyAvatar from "../../assets/assets/reapply-avatar.svg";

const ReapplySection = (props) => {
  const { href, type, title, disabled, application } = props;

  const check = application && application.length > 0;

  return (
    <div className="reapply-section">
      <div className="image1">
        <img src={ReapplyDoc} alt="icon" />
      </div>
      <div className="mid-sec">
        <h1>{title}</h1>
        <h3>
          Do you want to apply for {check ? "another" : ""} <br /> {type}?
        </h3>
        <a href={href}>
          <button disabled={disabled}>
            <span>APPLY NOW</span> <img src={Arrow} alt="forward" />
          </button>
        </a>
      </div>
      <div className="image2">
        <img src={ReapplyAvatar} alt="icon" />
      </div>
    </div>
  );
};

ReapplySection.propTypes = {
  application: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.shape({
      length: PropTypes.number,
    }),
  ]),
  disabled: PropTypes.any,
  href: PropTypes.any,
  title: PropTypes.any,
  type: PropTypes.string,
};

export default ReapplySection;
